import { render, staticRenderFns } from "./Breadcrumb.vue?vue&type=template&id=55d0181b&scoped=true&"
import script from "./Breadcrumb.vue?vue&type=script&lang=ts&"
export * from "./Breadcrumb.vue?vue&type=script&lang=ts&"
import style0 from "./Breadcrumb.vue?vue&type=style&index=0&id=55d0181b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d0181b",
  null
  
)

export default component.exports